import React, { useEffect, useMemo } from 'react';
import { awardIcon, awardColor, AWARD_COLORS } from '../utils/awardStyles';
import { playCelebration } from '../utils/sound';

const CONFETTI_COLORS = Object.values(AWARD_COLORS);

// Full-screen celebration shown on the operator's screen when they receive an award.
export default function AwardCelebration({ award, onClose, congratsLabel = 'Congratulations', hintLabel = 'Tap anywhere to continue' }) {
  const pieces = useMemo(() => Array.from({ length: 70 }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.8,
    duration: 2.4 + Math.random() * 1.8,
    size: 7 + Math.random() * 9,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    rotate: Math.random() * 360,
    round: Math.random() > 0.5,
  })), []);

  useEffect(() => {
    if (!award) return;
    playCelebration();
    const id = setTimeout(onClose, 6500);
    return () => clearTimeout(id);
  }, [award, onClose]);

  if (!award) return null;
  const Icon = awardIcon(award.icon);
  const color = awardColor(award.color);

  return (
    <div className="kmt-celebrate-overlay" onClick={onClose} data-testid="award-celebration">
      <div className="kmt-confetti-layer" aria-hidden>
        {pieces.map((p) => (
          <span key={p.id} className="kmt-confetti"
            style={{
              left: `${p.left}%`, width: p.size, height: p.size, background: p.color,
              borderRadius: p.round ? '50%' : 2,
              animationDelay: `${p.delay}s`, animationDuration: `${p.duration}s`,
              transform: `rotate(${p.rotate}deg)`,
            }} />
        ))}
      </div>
      <div className="kmt-celebrate-card" onClick={(e) => e.stopPropagation()} data-testid="award-celebration-card">
        <div className="kmt-celebrate-rays" style={{ background: `conic-gradient(from 0deg, ${color}00, ${color}55, ${color}00, ${color}55, ${color}00)` }} />
        <div className="kmt-celebrate-medal" style={{ background: `${color}22`, boxShadow: `0 0 40px ${color}66` }}>
          <Icon size={72} style={{ color }} strokeWidth={1.6} />
        </div>
        <div className="kmt-label mt-5" style={{ letterSpacing: '0.2em', color }}>{congratsLabel}</div>
        <div className="font-display font-bold mt-2" style={{ fontSize: 30, color }} data-testid="celebration-title">{award.title}</div>
        {award.description && <div className="text-sm mt-2 max-w-sm" style={{ color: 'var(--kmt-muted)' }}>{award.description}</div>}
        <div className="text-xs mt-4" style={{ color: 'var(--kmt-muted-2)' }}>{hintLabel}</div>
      </div>
    </div>
  );
}
